import { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";

type NormalizedDescriptionFilters = Pick<
    FiltersTypes,
    "normalizedDescriptionId" | "normalizedDescriptionIds"
>;

export function useSelectedNormalizedDescriptionIds(
    filters: NormalizedDescriptionFilters,
    mergedToCanonicalMap: Record<string, string> | undefined,
): string[] {
    return useMemo(
        () => [
            ...new Set(
                [
                    ...(filters.normalizedDescriptionIds ?? []),
                    ...(filters.normalizedDescriptionId
                        ? [filters.normalizedDescriptionId]
                        : []),
                ].map(
                    (id) =>
                        (mergedToCanonicalMap
                            ? mergedToCanonicalMap[id]
                            : undefined) ?? id,
                ),
            ),
        ],
        [
            filters.normalizedDescriptionId,
            filters.normalizedDescriptionIds,
            mergedToCanonicalMap,
        ],
    );
}
